import { render, staticRenderFns } from "./ListPurchasesOrderPage.vue?vue&type=template&id=1fd79588"
import script from "./ListPurchasesOrderPage.vue?vue&type=script&lang=js"
export * from "./ListPurchasesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports